// import react functionality
import React from "react";

// imports scss files
import "../../styles/Global.scss";
import "../../styles/components/misc/AboutUs.scss";

// import MUI components

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function AboutUsMemberContainerRight(props) {
  return (
    <div>
      <Box sx={{ flexGrow: 1, boxShadow: 3 }} className="Box">
        <div className="aboutRow">
          <div className="aboutElement" id="right">
            <img src={props.img} alt="Michel Schrem"></img>
          </div>
          <div className="aboutElement" id="right">
            <Typography variant="h2" color="primary" className="aboutHeading">
              {props.name}
              <span>{props.function}</span>
            </Typography>
            <Typography>{props.desc}</Typography>
          </div>
        </div>
      </Box>
    </div>
  );
}
